import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { addDays, format, parseISO } from 'date-fns';
import { queryNoticeFillAdopt, queryNoticeCate, enableNotice } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '紧急状态',
      dataIndex: 'emergency',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'emergency'
      }
    }, {
      title: '公告分类',
      dataIndex: 'cateName',
      align: 'center',
      width: 100
    }, {
      title: '公告标题',
      dataIndex: 'title',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '是否置顶',
      dataIndex: 'isTop',
      align: 'center',
      width: 80,
      customRender: function customRender(isTop) {
        if (0 === isTop) {
          return '否';
        } else if (1 === isTop) {
          return '是';
        } else {
          return '';
        }
      }
    }, {
      title: '拟稿人 / 发布人',
      dataIndex: 'releaseTemp',
      align: 'center',
      width: 150,
      scopedSlots: {
        customRender: 'releaseTemp'
      }
    }, {
      title: '拟稿时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 100
    }, {
      title: '发布范围',
      dataIndex: 'range',
      ellipsis: true,
      align: 'center',
      width: 100,
      customRender: function customRender(range) {
        if (0 === range) {
          return '全校教职工';
        } else if (1 === range) {
          return '自定义';
        } else if (2 === range) {
          return '当前组织层级';
        } else if (3 === range) {
          return '当前组织层级指定人员';
        } else {
          return '';
        }
      }
    }, {
      title: '公告状态',
      dataIndex: 'noticeStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'noticeStatus'
      }
    }, {
      title: '启停状态',
      dataIndex: 'status',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      expand: false,
      cateList: [],
      where: {
        cateId: '',
        status: '',
        emergency: '',
        startAndEndTime: [],
        title: '',
        startTime: '',
        endTime: ''
      },
      data: [],
      pagination: this.$hdk.page()
    };
  },
  created: function created() {
    var fetch = this.fetch,
      getNoticeCate = this.getNoticeCate;
    fetch();
    getNoticeCate();
  },
  methods: {
    /*
     * 根据条件搜索通知公告
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;

      // 日期格式化
      if (where.startAndEndTime.length > 0) {
        this.where.startTime = parseISO(format(where.startAndEndTime[0]._d, 'yyyy-MM-dd'));
        this.where.endTime = parseISO(format(where.startAndEndTime[1]._d, 'yyyy-MM-dd'));
      } else {
        this.where.startTime = null;
        this.where.endTime = null;
      }
      if (!pager.where) {
        pager.where = where;
      }
      queryNoticeFillAdopt(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /*
     * 公告分类
     */
    getNoticeCate: function getNoticeCate() {
      var _this2 = this;
      queryNoticeCate().then(function (res) {
        _this2.cateList = res.data.data;
      });
    },
    /*
     * 启用停用通知公告
     */
    enabling: function enabling(row) {
      var $message = this.$message,
        fetch = this.fetch;
      if (row.disabled) {
        $message.error('你无权限进行启用、停用');
        return;
      } else {
        var status = 1 === row.status ? 0 : 1;
        enableNotice(row.id).then(function (res) {
          if (res.data.code == 200) {
            row.status = status;
            fetch();
          }
        });
      }
    },
    /*
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 打开查阅情况
     */
    viewSituation: function viewSituation(row) {
      this.$router.push({
        path: '/docNotice/notice/consult',
        query: {
          id: row.id
        }
      });
    },
    /**
     * 查看详情
     */
    viewDetail: function viewDetail(row) {
      this.$router.push({
        path: '/docNotice/notice/auditNotice',
        query: {
          id: row.id,
          type: 3
        }
      });
    },
    /**
     * 打开反馈信息
     */
    feedback: function feedback(row) {
      this.$router.push({
        path: '/docNotice/notice/feedback',
        query: {
          id: row.id
        }
      });
    }
  }
};